export const CUSTOMER_RANK_ID = "39B15B05-C7DC-4264-A48A-7C31CC0B10D8";

export const SPONSOR_GENEALOGY_ID = "BD1F184A-DC3C-4221-B5FE-E5B982DC9D41";
